module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch5_20210921134151_T.b88951d2.jpg";